<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg p-6 max-w-2xl w-full">
      <div class="flex justify-between items-start mb-4">
        <h2 class="text-xl font-bold">Schedule Call</h2>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <XMarkIcon class="w-6 h-6" />
        </button>
      </div>
      
      <form @submit.prevent="save" class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Select Profile *</label>
          <select v-model="form.profile_id" class="input w-full" required>
            <option value="">Choose a profile...</option>
            <option v-for="profile in profiles" :key="profile.id" :value="profile.id">
              {{ profile.name }}
            </option>
          </select>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Date *</label>
            <input v-model="form.date" type="date" class="input w-full" required />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Time *</label>
            <input v-model="form.time" type="time" class="input w-full" required />
          </div>
        </div>
        
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Repeat</label>
          <select v-model="form.repeat" class="input w-full">
            <option value="none">No repeat</option>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
        </div>
        
        <div class="flex justify-end space-x-2">
          <button type="button" @click="$emit('close')" class="btn btn-secondary">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary">
            Schedule Call
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { useProfileStore } from '@/stores/profiles'

const emit = defineEmits(['close', 'save'])

const form = ref({
  profile_id: '',
  date: '',
  time: '',
  repeat: 'none'
})

const profileStore = useProfileStore()
const profiles = computed(() => profileStore.profiles)

onMounted(async () => {
  if (!profiles.value?.length) {
    try { await profileStore.fetchProfiles() } catch {}
  }
})

function save() {
  emit('save', form.value)
}
</script>
